import { render, staticRenderFns } from "./StopCard.vue?vue&type=template&id=cb0a5ce6&scoped=true&"
import script from "./StopCard.vue?vue&type=script&lang=js&"
export * from "./StopCard.vue?vue&type=script&lang=js&"
import style0 from "./StopCard.vue?vue&type=style&index=0&id=cb0a5ce6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb0a5ce6",
  null
  
)

export default component.exports